#import '../../../../core-entity/graphql/fragments/core-entity-task-step-shared-fragment.graphql'

fragment LeadStepFragment on Step {
    ...CoreEntityTaskStepSharedFragment
    relatedLead {
        id
        name
    }
    delays {
        id
        displayLength
    }
    stage {
        id
        name
    }
    linkifiedDescription
}
